module.exports = __webpack_public_path__ + "static/self3-72e85a216c8dff21736cc7c62cea7a2a.png";